<div class="stepper-page" [class.animate]="animate()">
  <ng-content></ng-content>
</div>
